import { apiClient, assertOk } from "@/api/generated/client.ts"

import type { KPIUpdateRequest } from "../types/kpiEditorTypes.ts"

export const upsertKPI = async (req: KPIUpdateRequest, id?: number) => {
  if (id != undefined) {
    const { error, response } = await apiClient.PUT("/api/KPIs/{id}", {
      params: { path: { id } },
      body: req,
    })
    assertOk(response, error)
  } else {
    const { error, response } = await apiClient.POST("/api/KPIs", {
      body: req,
    })
    assertOk(response, error)
  }
}
